var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 31,
    viewBox: "0 0 32 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_783_5129)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.7782 15.4664C31.7782 23.1414 25.9675 29.5029 18.3717 30.6561V19.9112H22.074L22.7785 15.4664H18.3717V12.5821C18.3717 11.3658 18.9875 10.1807 20.9612 10.1807H22.9647V6.39662C22.9647 6.39662 21.1461 6.0963 19.4076 6.0963C15.7786 6.0963 13.4064 8.22499 13.4064 12.0787V15.4664H9.37207V19.9112H13.4064V30.6561C5.81069 29.5029 0 23.1414 0 15.4664C0 6.97444 7.11409 0.0898438 15.8891 0.0898438C24.6641 0.0898438 31.7782 6.97444 31.7782 15.4664Z",
    fill: "#1877F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.073 19.9125L22.7775 15.4677H18.3708V12.5834C18.3708 11.3674 18.9863 10.182 20.9601 10.182H22.9637V6.39798C22.9637 6.39798 21.1454 6.09766 19.407 6.09766C15.7776 6.09766 13.4054 8.22634 13.4054 12.0801V15.4677H9.37109V19.9125H13.4054V30.6574C14.2144 30.7802 15.0435 30.8443 15.8881 30.8443C16.7327 30.8443 17.5618 30.7802 18.3708 30.6574V19.9125H22.073Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_783_5129"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 31.7782,
    height: 30.7531,
    fill: "white",
    transform: "translate(0 0.0898438)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.9b8f71854f26ba31bc89a652b90109ca.svg";
export { ForwardRef as ReactComponent };